export default "__VITE_ASSET__d6652a24__"